import './bootstrap';
import './flowbite';
import Vue from 'vue';

window.Vue = Vue;

import route from '../../vendor/tightenco/ziggy/src/js/Route.js';
import { Ziggy } from './ziggy';
import VTooltip from 'v-tooltip'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

window.csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');

window.axios.default.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfToken;

Vue.prototype.$eventHub = new Vue();

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    },
});

Vue.use(VTooltip);

Vue.component('base-card', require('./components/BaseCard.vue').default);
Vue.component('base-heading-main', require('./components/BaseHeadingMain.vue').default);
Vue.component('base-heading-secondary', require('./components/BaseHeadingSecondary.vue').default);
Vue.component('base-input-field', require('./components/BaseInputField.vue').default);
Vue.component('base-card-list', require('./components/BaseCardList.vue').default);
Vue.component('base-card-list-entry', require('./components/BaseCardListEntry.vue').default);
Vue.component('base-list-with-heading', require('./components/BaseListWithHeading.vue').default);
Vue.component('base-list-with-heading-entry', require('./components/BaseListWithHeadingEntry.vue').default);
Vue.component('base-loading-indicator-box', require('./components/BaseLoadingIndicatorBox.vue').default);
Vue.component('incident-list-with-heading', require('./components/IncidentListWithHeading.vue').default);
Vue.component('service-incident-list-with-heading', require('./components/ServiceIncidentListWithHeading.vue').default);
Vue.component('incident-card-list', require('./components/IncidentCardList.vue').default);
Vue.component('service-incident-card-list', require('./components/ServiceIncidentCardList.vue').default);
Vue.component('incident-card-list-entry', require('./components/IncidentCardListEntry.vue').default);
Vue.component('service-incident-card-list-entry', require('./components/ServiceIncidentCardListEntry.vue').default);
Vue.component('incident-list-with-heading-entry', require('./components/IncidentListWithHeadingEntry.vue').default);
Vue.component('service-incident-list-with-heading-entry', require('./components/ServiceIncidentListWithHeadingEntry.vue').default);
Vue.component('incident-history', require('./components/IncidentHistory.vue').default);
Vue.component('service-status-card', require('./components/ServiceStatusCard.vue').default);
Vue.component('location-status-list', require('./components/LocationStatusList.vue').default);
Vue.component('host-list', require('./components/HostList.vue').default);
Vue.component('host-card-list', require('./components/HostCardList.vue').default);
Vue.component('host-card-list-entry', require('./components/HostCardListEntry.vue').default);
Vue.component('host', require('./components/Host.vue').default);
Vue.component('location', require('./components/Location.vue').default);
Vue.component('dashboard', require('./components/Dashboard.vue').default);
Vue.component('refresh-data-button', require('./components/RefreshDataButton.vue').default);
Vue.component('modal', require('./components/Modal.vue').default);
Vue.component('pinned-interruptions', require('./components/PinnedInterruptions.vue').default);
Vue.component('rate-limit-exceeded-modal', require('./components/RateLimitExceededModal.vue').default);
Vue.component('login-form', require('./components/LoginForm.vue').default);
Vue.component('subscribe-button', require('./components/SubscribeButton.vue').default);
Vue.component('subscribe-modal', require('./components/SubscribeModal.vue').default);
Vue.component('zap-services-status-list', require('./components/ZapServicesStatusList.vue').default);
Vue.component('simple-service-status-card', require('./components/SimpleServiceStatusCard.vue').default);
Vue.component('interruption-comment', require('./components/InterruptionComment.vue').default);
Vue.component('interruption', require('./components/Interruption.vue').default);
Vue.component('interruption-summary', require('./components/InterruptionSummary.vue').default);
Vue.component('interruption-lookup', require('./components/InterruptionLookup.vue').default);
Vue.component('zap-service', require('./components/ZapService.vue').default);
Vue.component('zap-service-interruption', require('./components/ZapServiceInterruption.vue').default);

Sentry.init({
    Vue,
    dsn: "https://57d88938a6e08287148875f48c057596@logging.zap-srv.com/2",
    release: "9426413df9330891b6e20cd38a9821a369826aac",
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
        new BrowserTracing({
            tracingOrigins: ["status.zap-hosting.com", /^\//],
        }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

const app = new Vue({
    el: '#app',
});
